import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Button from "../../atoms/Button";
import { ReactComponent as Logo } from "../../../components/svgs/logo.svg";

const AboutUsHeader = () => {
  const { isAuth } = useSelector((state) => state.authReducer);
  return (
    <div className="flex justify-between py-4 px-10 bg-white">
      <div className="mx-10">
      <Link to="/">
        <Logo className="w-full h-full" />
        </Link>
      </div>
      <div className="flex items-center gap-6 text-base font-normal ">
        <Link to="/">
          <p>Home</p>
        </Link>
        <Link to="/about-us">
          <p>About Us</p>
        </Link>
        <Link to="/contact-us">
          <p>Contact Us</p>
        </Link>
        <Link to="/terms">
          <p>T & C</p>
        </Link>
        <Link to="/privacy">
          <p>Privacy policy</p>
        </Link>
      </div>
      <div className="my-auto">
        {!isAuth && (
          <Link to={"/user-portal"}>
            <Button
              varient="primary"
              borderColor="black"
              color="blue"
              className="text-sm  px-6 py-2 text-white mr-5"
            >
              Login / Signup
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default AboutUsHeader;
